const trackEvent = (eventName, params = {}) => {
  if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
    window.gtag('event', eventName, params);
  }
};

export const trackGameSelect = (gameName, gameUuid) => {
  trackEvent('game_select', {
    module: 'home',
    game_name: gameName,
    game_uuid: gameUuid
  });
};

export const trackTabAttempt = (tabName, currentLevel, page = 'home') => {
  trackEvent('skill_tab_attempt', {
    module: 'navigation',
    attempted_tab: tabName,
    current_skill_level: currentLevel,
    page_location: page
  });
};

export const trackTabSuccess = (tabName, currentLevel, page = 'home') => {
  trackEvent('skill_tab_success', {
    module: 'navigation',
    selected_tab: tabName,
    current_skill_level: currentLevel,
    page_location: page
  });
};

export const trackTabBlocked = (tabName, currentLevel, reason, page = 'home') => {
  trackEvent('skill_tab_blocked', {
    module: 'navigation',
    attempted_tab: tabName,
    current_skill_level: currentLevel,
    block_reason: reason,
    page_location: page
  });
};

export const trackTestSkillsDialogOpen = (skillLevel) => {
  trackEvent('test_skills_dialog_open', {
    module: 'gameplay',
    current_skill_level: skillLevel
  });
};

export const trackPlayNowClick = (skillLevel) => {
  trackEvent('play_now_click', {
    module: 'gameplay',
    current_skill_level: skillLevel
  });
};

export const trackTestSkillsDialogClose = (skillLevel, playedGame = false) => {
  trackEvent('test_skills_dialog_close', {
    module: 'gameplay',
    current_skill_level: skillLevel,
    played_game: playedGame
  });
};

export const trackGameStart = () => {
  trackEvent('aimtrain_game_start', {
    module: 'gameplay',
    start_timestamp: Date.now()
  });
};

export const trackGameEnd = (durationSeconds, reason = 'component_unmount') => {
  trackEvent('aimtrain_game_end', {
    module: 'gameplay',
    duration_seconds: Math.round(durationSeconds),
    duration_minutes: Math.round(durationSeconds / 60 * 100) / 100,
    end_reason: reason
  });
};

export const trackGameError = (errorType) => {
  trackEvent('aimtrain_game_error', {
    module: 'gameplay',
    error_type: errorType
  });
};

export const trackProfileEditAttempt = () => {
  trackEvent('profile_edit_attempt', {
    module: 'profile'
  });
};

export const trackProfileEditSuccess = () => {
  trackEvent('profile_edit_success', {
    module: 'profile'
  });
};

export const trackProfileEditFailure = (errorMessage) => {
  trackEvent('profile_edit_failure', {
    module: 'profile',
    error_message: errorMessage
  });
};

export const trackPuzzleView = (puzzleId, puzzleName) => {
  trackEvent('puzzle_view', {
    module: 'puzzle',
    puzzle_id: puzzleId,
    puzzle_name: puzzleName
  });
};

export const trackEasterEggUnlockAttempt = (puzzleId, partId) => {
  trackEvent('easter_egg_unlock_attempt', {
    module: 'puzzle',
    puzzle_id: puzzleId,
    part_id: partId
  });
};

export const trackEasterEggUnlockSuccess = (puzzleId, partId) => {
  trackEvent('easter_egg_unlock_success', {
    module: 'puzzle',
    puzzle_id: puzzleId,
    part_id: partId
  });
};

export const trackEasterEggUnlockFailure = (puzzleId, partId, errorMessage) => {
  trackEvent('easter_egg_unlock_failure', {
    module: 'puzzle',
    puzzle_id: puzzleId,
    part_id: partId,
    error_message: errorMessage
  });
};

export const trackPuzzleComplete = (puzzleId, puzzleName) => {
  trackEvent('puzzle_complete', {
    module: 'puzzle',
    puzzle_id: puzzleId,
    puzzle_name: puzzleName
  });
};

export const trackEasterEggPopupShown = (podcastId, easterEggCode) => {
  trackEvent('easter_egg_popup_shown', {
    module: 'video',
    podcast_id: podcastId,
    easter_egg_code: easterEggCode
  });
};

export const trackEasterEggPopupClosed = (podcastId, codeCopied = false) => {
  trackEvent('easter_egg_popup_closed', {
    module: 'video',
    podcast_id: podcastId,
    code_copied: codeCopied
  });
};

export const trackRedeemDialogOpen = (puzzleId, puzzleName) => {
  trackEvent('redeem_dialog_open', {
    module: 'redemption',
    puzzle_id: puzzleId,
    puzzle_name: puzzleName
  });
};

export const trackRedeemItemSelect = (puzzleId, itemId, itemName) => {
  trackEvent('redeem_item_select', {
    module: 'redemption',
    puzzle_id: puzzleId,
    item_id: itemId,
    item_name: itemName
  });
};

export const trackRedeemAttempt = (puzzleId, itemId) => {
  trackEvent('redeem_attempt', {
    module: 'redemption',
    puzzle_id: puzzleId,
    item_id: itemId
  });
};

export const trackRedeemKoFailure = (puzzleId, itemId, detailsMessage) => {
  trackEvent('redeem_ko_failure', {
    module: 'redemption',
    puzzle_id: puzzleId,
    item_id: itemId,
    failure_reason: detailsMessage
  });
};

export const trackRedeemError = (puzzleId, itemId, errorMessage) => {
  trackEvent('redeem_error', {
    module: 'redemption',
    puzzle_id: puzzleId,
    item_id: itemId,
    error_message: errorMessage
  });
};

export const trackRedeemProceedToSubmit = (puzzleId, itemName) => {
  trackEvent('redeem_proceed_to_submit', {
    module: 'redemption',
    puzzle_id: puzzleId,
    item_name: itemName
  });
};

export const trackClaimFormSubmit = (itemName) => {
  trackEvent('claim_form_submit', {
    module: 'redemption',
    item_name: itemName
  });
};

export const trackRedemptionSuccess = (itemName, puzzleId) => {
  trackEvent('redemption_success', {
    module: 'redemption',
    item_name: itemName,
    puzzle_id: puzzleId
  });
};

export const trackRedemptionFailure = (itemName, puzzleId, errorMessage) => {
  trackEvent('redemption_failure', {
    module: 'redemption',
    item_name: itemName,
    puzzle_id: puzzleId,
    error_message: errorMessage
  });
};
